export default __webpack_public_path__ + "static/media/minhatrilhabg.17bb7ecb.jpg";